'use strict'
module.exports = {
    NODE_ENV: '"production"',
    API_ROOT: '"https://service-web.szdreamerstech.com"'
}